/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectAssetRefDto } from './projectAssetRefDto';
import { MakeBuyoutRights } from './makeBuyoutRights';
import { CompanyBrandRefDto } from './companyBrandRefDto';
import { ProjectTaskRefDto } from './projectTaskRefDto';
import { TeamRefDto } from './teamRefDto';
import { UsageRights } from './usageRights';
import { CompanyRefDto } from './companyRefDto';
import { UserInfo } from './userInfo';
import { AssetDomain } from './assetDomain';
import { CreateAssetFileDto } from './createAssetFileDto';
import { AssetVersionRef } from './assetVersionRef';
import { UserRefDto } from './userRefDto';


export interface CreateAssetDto { 
    name: string;
    assetType: CreateAssetDto.AssetTypeEnum;
    status: CreateAssetDto.StatusEnum;
    previousStatus?: CreateAssetDto.PreviousStatusEnum;
    mainFile: CreateAssetFileDto;
    domains?: Array<AssetDomain>;
    agency?: CompanyRefDto;
    client?: CompanyRefDto;
    brand?: CompanyBrandRefDto;
    projects?: Array<ProjectAssetRefDto>;
    teams?: Array<TeamRefDto>;
    tasks?: Array<ProjectTaskRefDto>;
    user?: UserRefDto;
    subprojects?: Array<ProjectAssetRefDto>;
    description?: string;
    notes?: string;
    clusterType?: string;
    expiryDate?: string;
    tags?: Array<string>;
    currentVersion?: string;
    /**
     * All file versions as a reference
     */
    versions?: Array<AssetVersionRef>;
    owner?: UserInfo;
    customFields?: object;
    assetMedium?: string;
    usageRights?: Array<UsageRights>;
    makeBuyoutRights?: Array<MakeBuyoutRights>;
    jobNumber?: string;
}
export namespace CreateAssetDto {
    export type AssetTypeEnum = 'Image' | 'PDF' | 'Video' | 'Audio' | 'HTML Banner' | 'Powerpoint presentation' | 'ZIP' | 'Other';
    export const AssetTypeEnum = {
        Image: 'Image' as AssetTypeEnum,
        Pdf: 'PDF' as AssetTypeEnum,
        Video: 'Video' as AssetTypeEnum,
        Audio: 'Audio' as AssetTypeEnum,
        HtmlBanner: 'HTML Banner' as AssetTypeEnum,
        PowerpointPresentation: 'Powerpoint presentation' as AssetTypeEnum,
        Zip: 'ZIP' as AssetTypeEnum,
        Other: 'Other' as AssetTypeEnum
    };
    export type StatusEnum = 'approved' | 'rejected' | 'pending' | 'created' | 'expired' | 'uploaded' | 'awaiting_approval' | 'import' | 'failed' | 'archived' | 'draft';
    export const StatusEnum = {
        Approved: 'approved' as StatusEnum,
        Rejected: 'rejected' as StatusEnum,
        Pending: 'pending' as StatusEnum,
        Created: 'created' as StatusEnum,
        Expired: 'expired' as StatusEnum,
        Uploaded: 'uploaded' as StatusEnum,
        AwaitingApproval: 'awaiting_approval' as StatusEnum,
        Import: 'import' as StatusEnum,
        Failed: 'failed' as StatusEnum,
        Archived: 'archived' as StatusEnum,
        Draft: 'draft' as StatusEnum
    };
    export type PreviousStatusEnum = 'approved' | 'rejected' | 'pending' | 'created' | 'expired' | 'uploaded' | 'awaiting_approval' | 'import' | 'failed' | 'archived' | 'draft';
    export const PreviousStatusEnum = {
        Approved: 'approved' as PreviousStatusEnum,
        Rejected: 'rejected' as PreviousStatusEnum,
        Pending: 'pending' as PreviousStatusEnum,
        Created: 'created' as PreviousStatusEnum,
        Expired: 'expired' as PreviousStatusEnum,
        Uploaded: 'uploaded' as PreviousStatusEnum,
        AwaitingApproval: 'awaiting_approval' as PreviousStatusEnum,
        Import: 'import' as PreviousStatusEnum,
        Failed: 'failed' as PreviousStatusEnum,
        Archived: 'archived' as PreviousStatusEnum,
        Draft: 'draft' as PreviousStatusEnum
    };
}


